import React from "react";
import { Link } from "react-router-dom";
import { Check, Star, Lock } from "lucide-react";
import { CHAPTERS } from "../data/content";
import { CHAPTER_QUIZ, QUIZZES } from "../data/quizzes";
import { useProgress } from "../context/ProgressContext";
import { useAccess, isGated } from "../context/AccessContext";

function Marker({ chapterId }) {
  const { answers } = useProgress();
  const { unlocked } = useAccess();
  const gatedLocked = isGated(chapterId) && !unlocked;
  const quizKey = CHAPTER_QUIZ[chapterId];

  if (quizKey) {
    const qs = QUIZZES[quizKey].questions;
    const done = qs.filter((x) => answers[x.id]).length;
    if (done === qs.length && done > 0) {
      const allright = qs.every((x) => answers[x.id]?.correct);
      return allright ? (
        <Star size={12} className="text-[#2F6F4F] fill-[#2F6F4F]" />
      ) : (
        <Check size={12} className="text-[#2F6F4F]" />
      );
    }
  }
  if (gatedLocked) return <Lock size={11} className="text-[#1C2430]/30" />;
  return null;
}

export function LessonMenu({ currentId }) {
  const idx = CHAPTERS.findIndex((c) => c.id === currentId);
  const pct = ((idx + 1) / CHAPTERS.length) * 100;

  return (
    <nav className="hidden lg:block sticky top-0 h-screen pt-16 pb-10 pr-8 overflow-y-auto" data-testid="lesson-menu">
      <Link to="/" className="font-serif-display text-[19px] text-[#1C2430] leading-tight block mb-1 hover:text-[#2F6F4F] transition-colors" style={{ fontVariantNumeric: "lining-nums", fontFeatureSettings: '"lnum" 1' }} data-testid="menu-home-link">
        The MLA-C01<br />From-Zero Study Guide
      </Link>
      <div className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-[#1C2430]/45 mb-4 flex items-center gap-3">
        Lessons
        <div className="flex-1 h-px bg-[var(--border-light)] relative overflow-hidden">
          <div className="absolute inset-y-0 left-0 bg-[#2F6F4F]" style={{ width: `${pct}%` }} />
        </div>
      </div>
      <ul className="space-y-0.5">
        {CHAPTERS.map((c) => {
          const active = c.id === currentId;
          return (
            <li key={c.id}>
              <Link
                to={`/learn/${c.id}`}
                data-testid={`menu-link-${c.id}`}
                className={`group flex items-baseline gap-3 py-1 transition-colors ${
                  active ? "text-[#1C2430]" : "text-[#1C2430]/45 hover:text-[#1C2430]/80"
                }`}
              >
                <span className={`font-mono-ui text-[10px] tabular-nums ${active ? "text-[#2F6F4F]" : ""}`}>{c.num}</span>
                <span className={`text-[12.5px] leading-tight flex-1 ${active ? "font-semibold" : "font-normal"}`}>{c.title}</span>
                <span className="shrink-0 self-center"><Marker chapterId={c.id} /></span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
